import { useCallback, useEffect, useState } from 'react'
import { useCookie } from "react-use";
import { useProSidebar } from 'react-pro-sidebar';

import AppSidebar from './AppSidebar';
import Routing from './Routing';
// import MenuCreate from './components/Modals/MenuCreate';
import Modals from './components/Modals/Modals';

import './App.css'

function App() {
    const { collapseSidebar } = useProSidebar();

    const [cookieValue, updateCookieValue] = useCookie("expnd");
    const [expanded, setExpanded] = useState(cookieValue || 'expanded');

    useEffect(() => {
        if (expanded === 'collapsed') {
            collapseSidebar();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onExpand = useCallback(() => {
        let newExp;
        if (expanded === 'expanded') {
            newExp = 'collapsed';
        } else {
            newExp = 'expanded';
        }
        setExpanded(newExp);
        collapseSidebar();
        updateCookieValue(newExp);
    }, [expanded, setExpanded, collapseSidebar, updateCookieValue]);

    return (<>
        <Modals />
        <Routing expanded={expanded} sidebar={<AppSidebar expanded={expanded} onExpand={onExpand} />} />
    </>);
};

export default App;
